import { ThemeConfig, theme } from 'antd';


export const lightTheme:ThemeConfig = {
    algorithm: theme.defaultAlgorithm,
     token: {
      colorBgBase: '#F4F5F7',
      // Background color for the main app layout — like the page background or main wrapper

      colorBgContainer:'#ffffff',
      // Background color for containers — Cards, Modals, Panels, Dropdowns, and other content boxes

      colorText:'#334155',
      // Primary text color — used for main body text, headings, button text, etc. and  use in many other places ..global  search for find

      colorTextSecondary:'#64748B',
      // Secondary or muted text — subtitles, hints, descriptions, placeholder text, less important text

      colorBorder: '#E5E7EB',
      // Borders for inputs, selects, form controls, dividers, and other line separators

      colorBorderSecondary:'#E5E7EB',

      // Borders specifically for Cards, Panels, and some container borders

      colorSplit:'#E5E7EB',
      // for divider

      //custom bg color ====
      customBgColorOne:'#f4faff',
      customBgColorForFilterBarOne: '#FFF',
      //custom border color
      customBorderColor:  '#E5E7EB',
      customBorderColorTwo:'#E5E7EB',
      //custom text colo
      customColorTextTwo:'#1B73E8',

      //only for monitoring modal profile seciton======
      customBgColorForMonitoringCommonModal:'#EEF4FF',
      customBgForKeystrockesModal:'#fef08a ',
      customBgColorForScreenShootCard:'#FAFAFA',
      customSvgColorForScreenShootCard:'#6B7280',
      customSvgColorForProfileDetailsCard:'#6B7280',
      customBGForDeviceListCpuUsage:'#EFF8FF',
      customBgColorForMonthlyReportModalPP:'#EEF4FF',
      customDashboardBarChartLabelColor: '#334155',
    },
    components: {
      Menu: {
        itemColor:'#64748B', // normal text
        itemSelectedColor: '#1B73E8', // selected menu item text/icon color
        itemHoverColor: '#947DF0', // hover color
        itemSelectedBg: '#EFF8FF', // selected item background
        itemActiveBg:'#f0f5ff', // hover/active background
      },
      Layout: {
        siderBg:'#ffffff',
        colorBgHeader:'#ffffff',
      },
    
      Typography: {
        colorTextHeading: '#334155', // For Typography.Title
        colorText:'#64748B', // For Typography.Text
        // colorTextSecondary: isDark ? '#FFFFFFD9' : '#64748B', // for type="secondary"
      },
      Table: {
        headerBg: 'transparent',
        headerColor: '#64748B',
        rowHoverBg: '#f5f5f5',
        borderColor:'#E5E7EB',
      },
      Modal: {
        contentBg:'#FFF', // Modal background
        headerBg: '#FFF', // Modal header background
        titleColor:'#334155', // Modal title text color
        footerBg: 'transparent', // Optional: Footer background
      },
      Tabs: {
        colorBorderSecondary: '#FFF',
        itemColor:'#334155',
      },
      Card: {
        colorBorderSecondary: 'transparent',
        boxShadow: 'none', // Optional: remove shadow if you want a cleaner look
      },
    },
}

